import { useEffect, useState } from "react";
import { HttpMainApi } from "../../interface/main-api";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { useWindowSize } from "../../utils/useWindowSize";

interface propsType {
  index: number;
  runwayImg: string;
  season: string;
  designer: string;
  checked: boolean;
  callback: any;
}

const unAuthAPI = new HttpUnAuthApi();

const CardImageDetail = (props: propsType) => {
  const windowSize = useWindowSize();
  const isNarrow = (windowSize?.width ?? 0) <= 1023; // 1024 미만이면 모바일 취급
  const [imgSrc, setImgSrc] = useState("");

  useEffect(() => {
    // getImgUrl();
  }, [props.runwayImg]);

  const getImgUrl = async () => {
    const param = {
      command: "get_presigned_url",
      key: props.runwayImg
    };

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      console.log("res: ", res);
      setImgSrc(res.response.url);
    }
  };

  return (
    <>
      <div 
        className="brief-box one-third"
        style={{ 
          width:
          windowSize.width >= 1024
            ? "23%"
            : windowSize.width >= 640
            ? "31.3%"
            : "48%", }}
      >
        <div 
          className="thumb-img" 
          style={{ height: isNarrow?'274px':'324px', marginBottom: '12px' }}
          onClick={() => {
            props.callback({
              command: "showFullScreenImg",
              index: props.index,
              key: props.runwayImg
            })
          }}
        >
          <img src={props.runwayImg} />

        </div>

        <div className="brief-cont">
          <div className="main-brief">
            <div className="brief-summary" style={{ width: '100%' }}>
              <dd
                style={{ 
                  fontWeight: 400, 
                  fontSize: '14px',
                  color: '#8A8A8A',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                  {props.season + " " + props.designer + " " + String(props.index + 1).padStart(3, '0')}
              </dd>
            </div>

            <div 
              className="checkbox-wrap" 
              onClick={(e) => e.stopPropagation()}
              style={{ top: '7%', left: '15px' }}
            >
              <input
                type="checkbox"
                id={`checkRunway${props.index + 1}`}
                className="check-brief"
                onClick={() => {
                  props.callback({
                    command: "selectImage",
                    key: props.runwayImg,
                  });
                }}
                onChange={(e) => {}}
                checked={props.checked}
              />
              <label htmlFor={`checkRunway${props.index + 1}`}></label>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CardImageDetail;